<template>
    <BalanceAndTransactions
        v-bind:apiGetTransactionsAndBalance="$api.transaction.getTransactionsAndBalance"
        v-bind:workerId="user.user_id"
        v-bind:initializedOnPelican="false"
    >
    </BalanceAndTransactions>
</template>

<script>
    import BalanceAndTransactions from './BalanceAndTransactions';

    export default {
        props : {
            user: Object,
        },
        components: {BalanceAndTransactions}
    }
</script>